import api from "./api";

const LocationService = {
  getAll: async (pageNumber = 1, noOfRows = 20, search = "") => {
    const res = await api.get(
      `/location/getAll?pageNumber=${pageNumber}&noOfRows=${noOfRows}&search=${search}`
    );
    return res.data.data || res.data;
  },


  getById: async (id) => {
    const res = await api.get(`/location/getById/${id}`);
    return res.data;
  },

  getActive: async () => {
    const res = await api.get("/location/getActive");
    return res.data;
  },

  create: async (data) => {
    const res = await api.post("/location/save", data);
    return res.data;
  },

  updateStatus: async (id, status) => {
    const res = await api.put(`/location/updateStatus/${id}`, { status });
    return res.data;
  },

  update: async (id, locationData) => {
    const res = await api.put(`/location/update/${id}`, locationData);
    return res.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/location/${id}`);
    return res.data;
  },
};

export default LocationService;
